const DEFAULT_HEIGHT_BLOCK = 630;
/**
 * Компонент Читать больше.
 */
class ShowMoreText {
    /**
     * Создает компонент.
     *
     * @param {HTMLElement} el Элемент блока с текстом.
     */
    constructor(el) {
        this.el = el;
        this.wrapper = this.el.closest(".js-show-more-text-wrapper");
        this.baseHeight = this.wrapper.querySelector(".js-show-more-text-base");
        this.inner = this.el.querySelector(".js-show-more-inner");
        this.innerText = this.wrapper.querySelector(".js-show-more-text-list");
        this.link = this.el.querySelector(".js-show-more-link");
        this.breakpoint = this.el.dataset.breakpoint;
        this.checkHeight();
        this.bindEventListeners();
        this.addDocumentResizeObserver();
    }

    onResizeWindow = ([entry]) => {
        if (entry.contentRect.width < this.breakpoint) {
            this.checkHeight();
            if (this.link.classList.contains("hidden")) {
                this.link.classList.remove("hidden");
            }
        } else {
            this.showHiddenContent();
        }
    };

    addDocumentResizeObserver() {
        if (this.wrapper) {
            this.resizeObserver = new ResizeObserver(this.onResizeWindow);
            this.resizeObserver.observe(document.body);
        }
    }

    /**
     * Вешает колбеки на события.
     *
     * @returns {void}
     */
    bindEventListeners() {
        this.link.addEventListener("click", () => this.showHiddenContent());
    }

    /**
     * Проверяет, нужна ли кнопка "Читать больше...".
     *
     * @returns {void}
     */
    checkHeight() {
        const baseElStyle = this.baseHeight ? window.getComputedStyle(this.baseHeight, null) : null;
        const baseElHeight = this.baseHeight ? baseElStyle.getPropertyValue("height").replace("px", "") : DEFAULT_HEIGHT_BLOCK;

        this.inner.style.height = "auto";
        this.inner.style.maxHeight = "none";

        if (baseElHeight < this.inner.scrollHeight || this.innerText.offsetWidth > this.innerText.clientWidth) {
            this.link.classList.remove("hidden");
            this.el.style.minHeight = baseElHeight + "px";
            this.inner.style.maxHeight = baseElHeight + "px";
            // добавляем стили, чтобы при скрытии части текста последняя строка не обрезалась прямо по тексту
            const width = this.el.offsetWidth;
            this.inner.style.WebkitColumnWidth = width + "px";
            this.inner.style.columnWidth = width + "px";
            this.inner.style.height = "100%";
            this.inner.style.paddingBottom = "38px";
        } else {
            this.link.classList.add("hidden");
        }
    }

    /**
     * Развернуть скрытый контент, убрать ссылку "Читать больше".
     *
     * @returns {void}
     */
    showHiddenContent() {
        this.inner.style.height = "auto";
        this.inner.style.maxHeight = "none";
        this.inner.style.paddingBottom = 0;
        this.link.classList.add("hidden");
    }
}

document.querySelectorAll(".js-show-more-text").forEach((el) => new ShowMoreText(el));
